import React from 'react';
import { Row, Col } from '@paypalcorp/pp-react';
import PropTypes from 'prop-types';
import styles from './IntroSection.module.less';
import Overlay from '../../../components/Overlay';

const IntroSection = ({ ecmContent }) => {
  const { gettingStartedSummary, technicalOverview, checkoutSummary, checkoutSummarySteps } =
    ecmContent;
  const { text, imageUrl, descriptions, downloadName, overlayCaption } = technicalOverview;
  const { steps } = checkoutSummarySteps;

  return (
    <div className={`${styles.xo_container}`}>
      <div id="how-pp-checkout-works" dangerouslySetInnerHTML={{ __html: gettingStartedSummary }} />
      <div className={`${styles.getting_started_container}`}>
        <p className={`${styles.overview_title}`}>{text}</p>
        <Row className={`${styles.overview_container}`}>
          <Col xs={12} xxl={6}>
            <Overlay
              src={imageUrl}
              fileName={downloadName}
              caption={overlayCaption}
              className={`${styles.overlay}`}
            />
          </Col>
          <Col xs={12} xxl={6}>
            {descriptions.map((description, index) => (
              <div key={index} className={`${styles.description_wrapper}`}>
                <div className={`${styles.custom_badge}`}>
                  <p className={`${styles.custom_badge_text}`}>{index + 1}</p>
                </div>
                <div
                  className={`${styles.description_text}`}
                  dangerouslySetInnerHTML={{
                    __html: `<p>${description}</p>`
                  }}
                />
              </div>
            ))}
          </Col>
        </Row>
      </div>
      <div dangerouslySetInnerHTML={{ __html: checkoutSummary }} />
      <div className={`${styles.steps}`}>
        {steps.map((step, index) => (
          <div key={index} className={`${styles.steps_wrapper}`}>
            <div className={`${styles.custom_badge}`}>
              <p className={`${styles.custom_badge_text}`}>{index + 1}</p>
            </div>
            <div
              className={`${styles.text}`}
              dangerouslySetInnerHTML={{ __html: `<p>${step} </p>` }}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

IntroSection.propTypes = {
  ecmContent: PropTypes.object
};

IntroSection.defaultProps = {
  ecmContent: {
    content: {
      gettingStartedSummary: '',
      technicalOverview: { text: '', imageUrl: '', descriptions: [] },
      sxoSummary: ''
    }
  }
};

export default IntroSection;
